import { mergeAttributes } from '@tiptap/core';
import { Table } from '@tiptap/extension-table';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';

// Le tabelle dei report vengono stampate (A4 e 72mm): niente larghezze in pixel
// (colgroup, min-width, data-colwidth), la tabella occupa sempre il 100% del contenitore.
// Le larghezze delle colonne sono solo in percentuale (attributo "width" della cella) e
// il layout e' fisso (table-layout: fixed) cosi' le percentuali valgono ovunque.
// I bordi si decidono per tabella con l'attributo HTML border="1" (nessun CSS esterno necessario).

// Layout colonne predefiniti (percentuali per colonna)
export const TABLE_LAYOUTS: { value: string; label: string; widths: string[] }[] = [
    { value: '50-50', label: '2 colonne 50% - 50%', widths: ['50%', '50%'] },
    { value: '33-66', label: '2 colonne 33% - 66%', widths: ['33%', '67%'] },
    { value: '66-33', label: '2 colonne 66% - 33%', widths: ['67%', '33%'] },
    { value: '33-33-33', label: '3 colonne 33% - 33% - 33%', widths: ['33%', '34%', '33%'] }
];

const reportCellAttributes = function (this: any) {
    return {
        ...this.parent?.(),
        colwidth: {
            default: null,
            parseHTML: () => null,
            renderHTML: () => ({})
        },
        width: {
            default: null,
            parseHTML: (element: HTMLElement) =>
                element.style.width && element.style.width.endsWith('%') ? element.style.width : null,
            renderHTML: (attributes: Record<string, any>) =>
                attributes['width'] ? { style: `width: ${attributes['width']}` } : {}
        },
        verticalAlign: {
            default: null,
            parseHTML: (element: HTMLElement) => element.style.verticalAlign || null,
            renderHTML: (attributes: Record<string, any>) =>
                attributes['verticalAlign'] ? { style: `vertical-align: ${attributes['verticalAlign']}` } : {}
        }
    };
};

export const ReportTable = Table.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            bordered: {
                default: true,
                parseHTML: (element: HTMLElement) => element.getAttribute('border') === '1',
                renderHTML: () => ({})
            }
        };
    },

    renderHTML({ node, HTMLAttributes }) {
        const extra: Record<string, string> = { cellpadding: '4', cellspacing: '0' };
        if (node.attrs['bordered']) {
            extra['border'] = '1';
        }
        return [
            'table',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, extra, {
                style: 'width: 100%; border-collapse: collapse; table-layout: fixed'
            }),
            ['tbody', 0]
        ];
    }
});

export const ReportTableCell = TableCell.extend({
    addAttributes: reportCellAttributes
});

export const ReportTableHeader = TableHeader.extend({
    addAttributes: reportCellAttributes
});
